import React from "react";
import { Link } from "react-router-dom";

const ServiceCard = ({ img, title, sdescription, slug, number }) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <div
      className="services-card"
      style={{ height: "90%", display: "flex", flexDirection: "column" }}
    >
      <div className="number-shape">
        <span>{number}</span>
        <div className="shape">
          <svg viewBox="0 0 112 107" fill="none">
            <path
              id="Bg5"
              d="M67.9706 0.555039C89.2118 -0.484865 110.489 16.3952 111.529 37.6365C112.568 58.8777 92.9541 105.645 71.7129 106.685C50.4716 107.725 1.72311 63.4921 0.683209 42.2509C-0.356694 21.0097 46.7293 1.59494 67.9706 0.555039Z"
            />
          </svg>
        </div>
      </div>
      <div className="icon" style={{ marginBottom: "20px" }}>
        <img src={img} alt="" />
      </div>
      <h2
        style={{
          fontSize: "22px",
          lineHeight: "1.3",
          marginBottom: "15px",
          color: "#333",
        }}
      >
        {title}
      </h2>
      <span style={{ display: "block", color: "#666" }}>{sdescription}</span>
    </div>
  );
};

export default ServiceCard;
